// extracted by mini-css-extract-plugin
export default {"spinnerContainer":"spinnerContainer__CCPIH","spinnerIcon":"spinnerIcon__Czdsv"};